import { API } from "./axiosInstance"

/**
 * Gets all the authenticationMethods from usermanagement-service
 * @returns the authenticationMethods
 */
export const getauthenticationMethods = async () => {
    const authenticationMethods = await API.get(`/authenticationMethods`);
    return authenticationMethods.data;
}
